/**
 * Admin: grouped emoji picks for package “Includes” icons.
 */
import { LUCIDE_INCLUDE_ICON_SLUGS } from '../utils/feeIncludeIcons.js';

const emojiGroup = (label, pairs) => ({
  label,
  options: pairs.map(([value, text]) => ({ value, label: `${value} ${text}` }))
});

export const INCLUDE_ICON_EMOJI_GROUPS = [
  emojiGroup('Emojis — Home experience (same as homepage)', [
    ['❄️', 'Snow'],
    ['🚗', 'Car'],
    ['🏔️', 'Mountain'],
    ['🏕️', 'Camp'],
    ['🚴‍♂️', 'Cycle']
  ]),
  emojiGroup('Emojis — Transport', [
    ['✈️', 'Plane'],
    ['🛫', 'Takeoff'],
    ['🚁', 'Helicopter'],
    ['🚌', 'Bus'],
    ['🚎', 'Trolleybus'],
    ['🚃', 'Tram'],
    ['🚂', 'Train'],
    ['🚆', 'Train front'],
    ['🚇', 'Metro'],
    ['🚉', 'Station'],
    ['🚕', 'Taxi'],
    ['🛺', 'Auto rickshaw'],
    ['🚲', 'Bike'],
    ['🛵', 'Scooter'],
    ['🛻', 'Pickup'],
    ['🚙', 'SUV'],
    ['🚐', 'Van'],
    ['⛵', 'Sailboat'],
    ['🛥️', 'Motor boat'],
    ['🚤', 'Speedboat'],
    ['⚓', 'Anchor'],
    ['🗺️', 'Map'],
    ['🧭', 'Compass']
  ]),
  emojiGroup('Emojis — Nature & outdoors', [
    ['🏞️', 'National park'],
    ['🌲', 'Evergreen'],
    ['🌳', 'Tree'],
    ['🌴', 'Palm'],
    ['🌵', 'Cactus'],
    ['🌷', 'Tulip'],
    ['🌸', 'Cherry blossom'],
    ['🌺', 'Hibiscus'],
    ['🌻', 'Sunflower'],
    ['🌼', 'Blossom'],
    ['🍂', 'Fallen leaf'],
    ['🍃', 'Leaf flutter'],
    ['🌿', 'Herb'],
    ['☀️', 'Sun'],
    ['🌤️', 'Sun cloud'],
    ['⛅', 'Behind cloud'],
    ['🌥️', 'Cloud sun'],
    ['☁️', 'Cloud'],
    ['🌧️', 'Rain'],
    ['⛈️', 'Storm'],
    ['🌈', 'Rainbow'],
    ['☃️', 'Snowman'],
    ['🌊', 'Wave'],
    ['🪨', 'Rock'],
    ['⛰️', 'Mountain'],
    ['🌋', 'Volcano'],
    ['🏜️', 'Desert'],
    ['🏖️', 'Beach'],
    ['🦅', 'Eagle'],
    ['🦌', 'Deer'],
    ['🐻', 'Bear'],
    ['🦋', 'Butterfly']
  ]),
  emojiGroup('Emojis — Activities', [
    ['🥾', 'Hiking boot'],
    ['🧗', 'Climbing'],
    ['⛺', 'Tent'],
    ['🔥', 'Campfire'],
    ['🎒', 'Backpack'],
    ['🧴', 'Lotion'],
    ['🎯', 'Target'],
    ['🏆', 'Trophy'],
    ['🎖️', 'Medal'],
    ['📸', 'Camera flash'],
    ['🎥', 'Movie camera'],
    ['🎵', 'Music'],
    ['🎫', 'Ticket'],
    ['🛶', 'Canoe'],
    ['🏊', 'Swim'],
    ['⛷️', 'Skier'],
    ['🎿', 'Skis'],
    ['🛷', 'Sled'],
    ['🧊', 'Ice']
  ]),
  emojiGroup('Emojis — Stay & food', [
    ['🏨', 'Hotel'],
    ['🏠', 'House'],
    ['🏡', 'Home'],
    ['🛏️', 'Bed'],
    ['🍽️', 'Dining'],
    ['🍴', 'Fork knife'],
    ['🥘', 'Food'],
    ['☕', 'Coffee'],
    ['🍵', 'Tea'],
    ['🥤', 'Cup'],
    ['🍱', 'Bento'],
    ['🥪', 'Sandwich'],
    ['🍲', 'Stew'],
    ['🧃', 'Drink box'],
    ['🍼', 'Baby bottle']
  ]),
  emojiGroup('Emojis — Safety & support', [
    ['⛑️', 'Helmet'],
    ['🦺', 'Safety vest'],
    ['🩹', 'Bandage'],
    ['💊', 'Pill'],
    ['🩺', 'Stethoscope'],
    ['🏥', 'Hospital'],
    ['🚑', 'Ambulance'],
    ['📋', 'Clipboard'],
    ['📄', 'Document'],
    ['✅', 'Check'],
    ['⭐', 'Star'],
    ['💡', 'Idea'],
    ['📞', 'Phone'],
    ['💬', 'Chat'],
    ['🆘', 'SOS'],
    ['🛟', 'Life buoy']
  ]),
  emojiGroup('Emojis — People & groups', [
    ['👥', 'People'],
    ['👨‍👩‍👧', 'Family'],
    ['🧑‍🤝‍🧑', 'Holding hands'],
    ['🙋', 'Raise hand'],
    ['👋', 'Wave hand'],
    ['🤝', 'Handshake'],
    ['❤️', 'Heart'],
    ['💪', 'Muscle'],
    ['🧘', 'Meditation']
  ]),
  emojiGroup('Emojis — Money & booking', [
    ['💰', 'Money bag'],
    ['💳', 'Card'],
    ['🧾', 'Receipt'],
    ['📅', 'Calendar'],
    ['🕐', 'Clock'],
    ['🔔', 'Bell'],
    ['✉️', 'Mail']
  ]),
  emojiGroup('Emojis — Flags & regions', [
    ['🇮🇳', 'India'],
    ['🏳️', 'White flag'],
    ['🌍', 'Globe EU-Africa'],
    ['🌎', 'Globe Americas'],
    ['🌏', 'Globe Asia-Australia']
  ])
];

export function getIncludeIconSelectGroups() {
  return [
    ...INCLUDE_ICON_EMOJI_GROUPS,
    {
      label: 'Lucide icons (vector)',
      options: LUCIDE_INCLUDE_ICON_SLUGS.map((slug) => ({
        value: slug,
        label: slug
      }))
    }
  ];
}
